export default __webpack_public_path__ + "static/media/check.0854b252.svg";